import React from "react";
import {Card, CardBody} from "reactstrap";
import SpecialDaysHeader from "../../molecules/specialDaysHeader/specialDaysHeader";
import SpecialDaysDataList from "../../organisms/specialDaysDataList/specialDaysDataList";
import "./specialDaysTemplate.sass";

const SpecialDaysTemplate: React.FC = () => {
  return (
    <div className="special-days-template" data-testid="specialDaysTemplate">
      <Card>
        <SpecialDaysHeader />
        <CardBody>
          <SpecialDaysDataList />
        </CardBody>
      </Card>
    </div>
  );
};

export default SpecialDaysTemplate;
